import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-available-balance-card',
  templateUrl: './available-balance-card.component.html',
  styleUrls: ['./available-balance-card.component.scss'],
})
export class AvailableBalanceCardComponent implements OnInit {
  public isLoaded: boolean = false;
  public readyAmount: number = 0;

  constructor(private dashBoardService: DashboardService) {}

  ngOnInit(): void {
    this.getAvailableBalanceAmount();
  }

  getAvailableBalanceAmount() {
    this.isLoaded = true;

    this.dashBoardService
      .getAvailableBalanceAmount()
      .then((value) => {
        this.readyAmount = value;
      })
      .finally(() => {
        this.isLoaded = false;
      });
  }
}
